import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';

const adminAxios = axios.create({ baseURL });

adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers['X-Admin-Token'] = token;
  return config;
});

adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      // Reload AdminPage so it shows the login form
      window.dispatchEvent(new Event('admin-logout'));
    }
    return Promise.reject(error);
  }
);

export default adminAxios;
